import type { PurchaseResult, UserGear } from './gear';

type GearEvent = 'gear_purchase' | 'gear_equip' | 'gear_unequip';
type EventParameters = Record<string, string | number>;

declare global {
  interface Window {
    gtag?: (command: 'event', event: GearEvent, parameters: EventParameters) => void;
  }
}

function trackEvent(event: GearEvent, parameters: EventParameters): void {
  try {
    if (typeof window !== 'undefined') window.gtag?.('event', event, parameters);
  } catch { /* Analytics is best effort and must never interrupt gameplay. */ }
}

export function trackGearPurchase(result: PurchaseResult): void {
  const { gearId, goldSpent, outcome } = result.receipt;
  trackEvent('gear_purchase', { gear_id: gearId, gold_spent: goldSpent, outcome });
}

/** Compare confirmed loadouts so swaps include both the removed and added gear. */
export function trackGearEquipmentChanges(previous: UserGear, saved: UserGear): void {
  if (previous.userId !== saved.userId) return;
  for (const id of previous.equippedInstanceIds) {
    if (saved.equippedInstanceIds.includes(id)) continue;
    const item = previous.items.find((item) => item.id === id);
    if (item) trackEvent('gear_unequip', { gear_id: item.gearId });
  }
  for (const id of saved.equippedInstanceIds) {
    if (previous.equippedInstanceIds.includes(id)) continue;
    const item = saved.items.find((item) => item.id === id);
    if (item) trackEvent('gear_equip', { gear_id: item.gearId });
  }
}
